import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import RelatedPost from "../components/RelatedPost/RelatedPost";
import { fetchPost } from "../redux/features/post/postSlice";
import { patchPost } from "../redux/features/posts/postsSlice";
import { fetchRelatedPosts } from "../redux/features/relatedPosts/relatedPostsSlice";


export default function SingleBlogPage() {
  const { post, isLoading, isError, error } = useSelector(
    (state) => state.post
  );
  const dispatch = useDispatch();
  const { postId } = useParams();

  // load initial post and related post
  useEffect(() => {
    (async() => {
        const result =await dispatch(fetchPost(postId));
        if (fetchPost.fulfilled.match(result)) {
          dispatch(fetchRelatedPosts({id: result.payload.id, tags: result.payload.tags}));
        }
    })();
    
  }, [dispatch, postId]);

  const { id, image, title, tags, isSaved, likes, description } = post || {};

  const likeHandler = ()=>{
    dispatch(patchPost({id, data: {likes: likes+1}}))
}

const saveHandler = ()=>{
  dispatch(patchPost({id, data:{isSaved: !isSaved}}))
}

  let tagsView
  if(tags) tagsView = tags.map((tag , index)=>(
    index === 0 ? <span key={tag}>#{tag}</span> : 
    <span key={tag}>, #{tag}</span>))


  // decide what to render
  let content = null;
  if (isLoading) content = "Loading";

  if (!isLoading && isError)
    content = <div>{error}</div>;

  if (!isLoading && !isError && !post?.id) {
    content = <div>No Post found!</div>;
  }

  if (!isLoading && !isError && post?.id) {
    content = (<>
      <img src={image} alt="githum" className="w-full rounded-md" id="lws-megaThumb" />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tagsView}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button onClick={likeHandler} className="like-btn" id="lws-singleLinks">
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button onClick={saveHandler} className={`${isSaved && "active"} save-btn`} id="lws-singleSavedBtn">
            <i className="fa-regular fa-bookmark"></i>{isSaved ? " Saved" : " Save"}
          </button>
        </div>
        <div className="mt-6">
          <p>
            {description}
          </p>
        </div>
      </div>
    </>
    );
  }
  return (
    <>
      <div className="container mt-8">
        <Link to="/" className="inline-block text-gray-600 home-btn" id="lws-goHome"><i
          className="mr-2 fa-solid fa-house"></i>Go Home</Link>
      </div>
      <section className="post-page-container">
        <main className="post">
          {content}
        </main>
        <RelatedPost/>
      </section>
    </>
  )
};